import { defineMessage } from 'react-intl';

export const labelI18n = {
  districts: defineMessage({
    id: 'label.districts',
    defaultMessage: 'Districts'
  }),
  payWith: defineMessage({
    id: 'label.pay-with',
    defaultMessage: 'Pay with'
  }),
  noReviewsYet: defineMessage({
    id: 'label.no-reviews-yet',
    defaultMessage: 'No reviews yet'
  })
};
